import Vue from 'vue';
import moment_js from 'moment';

import './sass/app.scss';

window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js').default;

require('jquery.easing');

require('bootstrap');

require('./vendor/sb-admin-2.js');

Object.defineProperty(Vue.prototype, 'moment', { value: moment_js });
